export default {
  'cashStatement.title': '钱箱报表',
  'cashStatement.copy': '钱箱报表为您提供您餐厅各个钱箱的活动汇总和详情。',
  'cashStatement.timeRange.title': '时间区间',
  'cashStatement.device.title': '设备',
  'cashStatement.timeRange.today': '今天',
  'cashStatement.timeRange.yesterday': '昨天',
  'cashStatement.timeRange.thisWeek': '本周',
  'cashStatement.timeRange.lastWeek': '本周',
  'cashStatement.timeRange.thisMonth': '本月',
  'cashStatement.timeRange.lastMonth': '上月',
  'cashStatement.section.summary': '钱箱报表',
  'cashStatement.section.activity': '钱箱报表活动',
  'cashStatement.column.session_start_time': '钱箱开始时间',
  'cashStatement.column.session_end_time': '钱箱结算时间',
  'cashStatement.column.session_id': 'Session ID',
  'cashStatement.column.device_name': '设备名称',
  'cashStatement.column.start_balance': '初始金额',
  'cashStatement.column.cash_sales': '现金收入',
  'cashStatement.column.cash_tips': '现金小费',
  'cashStatement.column.miscellaneous_cash': '杂项收入',
  'cashStatement.column.other_cash_in': '其他入账原因',
  'cashStatement.column.cash_refund': '现金退款',
  'cashStatement.column.safe_drop': '保险箱提款',
  'cashStatement.column.cash_in': '入账',
  'cashStatement.column.cash_out': '出账',
  'cashStatement.column.employee_reimbursement': '员工报销',
  'cashStatement.column.tips_payout': '发放小费',
  'cashStatement.column.other_cash_out': '其他出账原因',
  'cashStatement.column.estimated_ending_balance': '预计期末金额',
  'cashStatement.column.total_cash_in': '总流入现金',
  'cashStatement.column.total_cash_out': '总出账现金',
  'cashStatement.column.total_cash_in.tooltip': '总流入现金包括现金收入，现金小费， 杂项收入， 和其他入账原因等。',
  'cashStatement.column.total_cash_out.tooltip':
    '总出账现金包括现金退款， 保险箱退款， 员工报销， 发放小费， 和其他出账原因等。',
  'cashStatement.column.time': '时间',
  'cashStatement.column.action': '类别',
  'cashStatement.column.amount': '金额',
  'cashStatement.column.employee_name': '员工',
  'cashStatement.column.reason': '原因',
};
